import { Action } from '@ngrx/store';

export enum LoaderActionTypes {
  ShowLoader = '[Loader] Show Loader',
  HideLoader = '[Loader] Hide Loader'
}

export class ShowLoader implements Action {
  readonly type = LoaderActionTypes.ShowLoader;

  constructor(public request) {
    this.request = request;
  }
}

export class HideLoader implements Action {
  readonly type = LoaderActionTypes.HideLoader;

  constructor(public request) {
    this.request = request;
  }
}

export type LoaderActions =
  | ShowLoader
  | HideLoader;
